<form [formGroup]="taxCategoryForm">
  <div class="row">
    <div class="col-lg-6 mb-3">
      <input-field
        [requiredLabel]="true"
        [label]="'Code'"
        [type]="'text'"
        [placeholder]="'Enter Code'"
        [errormessage]="'Code is required'"
        [required]="true"
        formControlName="code"
      >
      </input-field>
    </div>
    <div class="col-lg-6 mb-3">
      <input-field
        [label]="'Description'"
        [type]="'text'"
        [placeholder]="'Enter Description'"
        formControlName="description"
      >
      </input-field>
    </div>
  </div>
</form>
